"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LogoRender = {
  name: "LogoRender",
  functional: true,
  render: function render(h) {
    var dom = [h("svg-icon", {
      "attrs": {
        "iconName": "fe-logo"
      }
    }), h("h1", ["Fe-Admin"])];
    return dom;
  }
};
var _default = LogoRender;
exports.default = _default;